import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 80vh;  
  max-height: 90vh
  width: 100%;
  align-items: center;
  background: #f4f4f4;
  padding:2rem

  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 600px) {
    align-items: flex-start;}
`;
export const FormContainer = styled.form`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: normal;
  margin-bottom: 24px;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.9rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 1rem;
  font-family: 'Courier New', monospace;

  &:focus {
    outline: none;
    border-color: #c41e3a;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 1rem;
  min-height: 70px;
  font-family: 'Courier New', monospace;

  &:focus {
    outline: none;
    border-color: #c41e3a;
  }
`;

export const Button = styled.button`
  padding: 12px 24px;
  background: #000;
  color: white;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.9rem;
  margin-right: 8px;

  &:hover {
    background: #c41e3a;
  }

  ${props => props.cancel && `
    background: #666;
    &:hover {
      background: #444;
    }
  `}
`; 